export const hubsRouteLinks = {
    root: "/hubs",
    create: "/hubs/create",
    hub: (id: string) => ({
        root: `/hubs/${id}`,
        tasks: `/hubs/${id}/tasks`
    })
};
